import { Injectable } from '@angular/core';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { EMPTY, throwError, of } from 'rxjs';
import { map, catchError, exhaustMap, switchMap } from 'rxjs/operators';
import { HttpErrorResponse } from '@angular/common/http';
import { ViewService } from '@view/view.service';
import * as viewActions from '@view/store/view.actions';
import { View } from '@models';
import { errorTypes } from '@view/store/view.reducer';

@Injectable()
export class ViewEffects {
  changeDefaultViewStatus$ = createEffect(() => this.actions$.pipe(
    ofType(viewActions.changeDefaultViewStatus),
    exhaustMap((action) => this.viewService.setDefaultViewStatus(action.viewId, action.newStatus)
    .pipe(
      map((updatedView: View) => viewActions.defaultViewStatusChanged({row: updatedView})),
      catchError((err) => of(viewActions.failRequest(
        {error: err, errorType: errorTypes.creating}
      )))
    ))
  ));

  constructor(
    private actions$: Actions,
    private viewService: ViewService,
  ) { }
}
